import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { DefaultButton } from '@bingads-webui-react/fabric-with-signal';
import { getCurrentStepId, useWizardService, WIZARD_EVENTS } from '@bingads-webui-react/wizard';

export const AdFooter = ({
  i18n,
  enableCancel,
  enableCreateAnother,
}) => {
  const { send, state } = useWizardService();
  const stepId = useMemo(() => getCurrentStepId(state), [state]);

  const onSaveAndCreateAnother = useCallback(() => {
    send(WIZARD_EVENTS.SAVE_AND_GOTO, { stepId });
  }, [send, stepId]);

  const onCancel = useCallback(() => {
    send(WIZARD_EVENTS.NAVIGATE_TO, { stepId });
  }, [send, stepId]);

  return (
    <div className="ad-footer">
      {enableCreateAnother && (
        <DefaultButton onClick={onSaveAndCreateAnother}>
          {i18n.getString(_TL_('Save & create another ad'))}
        </DefaultButton>
      )}
      {enableCancel && (
        <DefaultButton onClick={onCancel}>
          {i18n.getString(_TL_('Cancel'))}
        </DefaultButton>
      )}
    </div>
  );
};

AdFooter.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  enableCancel: PropTypes.bool,
  enableCreateAnother: PropTypes.bool,
};

AdFooter.defaultProps = {
  enableCancel: false,
  enableCreateAnother: false,
};
